const releaseInWildRouter = [
    {
        path:'plan',
        name:'releaseInWild-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/releaseInWild/index.vue'),
        children:[
            {
                path:'',
                name:'releaseInWild-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
            },{
                path:'create/:id',
                name:'releaseInWild-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/releaseInWild/create.vue')
            },{
                path:'detail/:id',
                name:'releaseInWild-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/releaseInWild/detail.vue')
            },{
                path:'edit/:id',
                name:'releaseInWild-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/releaseInWild/edit.vue')
            },{
                path:'evaluate',
                name:'releaseInWild-evaluate',
                children:[
                    {
                        path:'create/:id',
                        name:'releaseInWild-evaluate-create',
                        component: () => import(/* webpackChunkName: "about" */ '../views/releaseInWild/evaluate/create.vue')
                    },{
                        path:'detail/:id',
                        name:'releaseInWild-evaluate-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/releaseInWild/evaluate/detail.vue')
                    },{
                        path:'edit/:id',
                        name:'releaseInWild-evaluate-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/releaseInWild/evaluate/edit.vue')
                    }
                ]
            }
        ]
    },{
        path:'map',
        name:'releaseInWild-map',
        component: () => import(/* webpackChunkName: "about" */ '../views/releaseInWild/map.vue'),
        
    }
  ]
  export default releaseInWildRouter

  